import React from 'react';
import posed from 'react-pose';

import * as Types from 'types';
import { request } from 'utils/request';
import { EditionDetailsContent } from 'editions/EditionDetails/EditionDetailsContent';
import { SpinnerWithLabel } from 'components/Spinner';

const downloadWallpaper = (certificateId: number) => {
  const path = Routes.vault_downloads_path({
    certificate_id: certificateId,
  });

  request.post<{ url: string }>(path).then(({ data }) => window.open(data.url));
};

const AnimationWrapper = posed.div({
  visible: { opacity: 1, transition: { duration: 500 } },
  hidden: { opacity: 0 },
});

type Props = {
  edition: Types.EditionWithArtwork;
  showGiftEdition: (editionId: number) => void;
  onMintClick: () => void;
  onRequestClose: () => void;
};

export const EditionDetails: React.FC<Props> = (props) => {
  const { edition, onMintClick, onRequestClose } = props;
  const certificateImageUrl = edition.certificate.imageUrl;
  const certificatePose = certificateImageUrl ? 'visible' : 'hidden';

  return (
    <div className='edition-details container-fluid'>
      <div className='row no-gutters'>
        <div className='col-12 col-md pos-rel'>
          <AnimationWrapper
            pose={certificatePose}
            style={{ backgroundImage: `url(${certificateImageUrl})` }}
            className='certificate-image-placeholder'
          />
          {!certificateImageUrl && (
            <div className='translate-into-middle'>
              <SpinnerWithLabel>Certificate is being generated</SpinnerWithLabel>
            </div>
          )}
        </div>
        <div className='col-12 col-md-5 col-lg-4'>
          <EditionDetailsContent
            edition={edition}
            onDownloadClick={() => downloadWallpaper(edition.certificate.id)}
            onGiftClick={() => props.showGiftEdition(edition.id)}
            onMintClick={onMintClick}
            onRequestClose={onRequestClose}
          />
        </div>
      </div>
    </div>
  );
};
